import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material"
import { useTranslation } from "react-i18next"
import { styles } from "./RecommendationAlert.styles"

export const RecommendationAlert = ({
  open,
  onClose,
  title = "",
  message = "",
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: styles.paper,
      }}
    >
      <DialogTitle sx={styles.title}>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent sx={styles.content}>
        <Typography variant="body1" sx={styles.text}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={styles.acceptButton}
          disableElevation
        >
          {t("accept", "Accept")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
